import React, { useState, Fragment } from 'react';

import './SearchEngine.scss';
import icons from '../../shared/assets/icons';
import ChannelList from '../ChannelList/ChannelList.jsx';
import ArticleList from '../ArticleList/ArticleList.jsx';
import CategoryList from '../CategoryList/CategoryList.jsx';

const { Filter } = icons;

const components = {
  channelList: ChannelList,
  articleList: ArticleList,
  categoryList: CategoryList
};

export default function SearchEngine(props) {
  const {
    user,
    filter,
    nextLink,
    searchType,
    foundTypes,
    totalQuantity,
    showLoginPopup,
    subscribeChannel,
    unsubscribeChannel,
    query: parsedQueryString
  } = props;

  const { query } = parsedQueryString;

  const channelsSearch = searchType === 'channels';

  const [popup, toggleFilterPopup] = useState(false);
  const [filteredTypes, updateFilteredTypes] = useState(new Set());

  return (
    <section id="searchEngine">
      <h1 id="searchEngine_title">
        {channelsSearch ? 'Kanalen overzicht' : 'Zoeken'}
      </h1>

      <form id="searchEngine_form" onSubmit={(e) => search(e)}>
        <div
          id="searchEngine_filter_button"
          onClick={() => totalQuantity && toggleFilterPopup(!popup)}
        >
          <Filter />
          Filteren
        </div>

        <input
          type="text"
          name="search"
          autoComplete="off"
          onKeyUp={(e) => filter && filter(e.target.value.trim())}
          placeholder={channelsSearch ? 'Zoek op naam of categorie' : query}
        />

        {!!filteredTypes.size && (
          <ul id="searchEngine_filtered_types">
            {[...filteredTypes].map((type, idx) => (
              <li key={idx}>
                {type}

                <span onClick={() => removeType(type)}>&times;</span>
              </li>
            ))}
          </ul>
        )}
      </form>

      {popup && (
        <ul id="searchEngine_filter_popup">
          {foundTypes.map((item, idx) => (
            <li key={idx} onClick={() => addType(item.type)}>
              <p>{item.type}</p>

              <span>{item.quantity} resultaten</span>
            </li>
          ))}
        </ul>
      )}

      <div id="searchEngine_results">
        <div id="searchEngine_total_result">
          <p>Resultaten {query && `voor '${query}'`}</p>

          <span>
            {filteredTypes.size
              ? [...filteredTypes].reduce((quantity, type) => {
                  const entry = foundTypes.find((entry) => entry.type === type);

                  if (!entry) return quantity;

                  quantity += entry.quantity;

                  return quantity;
                }, 0)
              : totalQuantity}{' '}
            resultaten
          </span>
        </div>

        {filteredTypes.size
          ? [...filteredTypes].map((type, idx) => {
              const entry = foundTypes.find((entry) => entry.type === type);

              if (!entry) return;

              return component(entry, idx);
            })
          : foundTypes.map((entry, idx) => component(entry, idx))}
      </div>
    </section>
  );

  function addType(type) {
    updateFilteredTypes(filteredTypes.add(type));

    toggleFilterPopup(!popup);
  }

  function removeType(type) {
    const newSet = new Set(filteredTypes);

    newSet.delete(type);

    updateFilteredTypes(newSet);
  }

  function title(type) {
    return (
      <p className="searchEngine_results_title">
        {type} {query && `voor '${query}'`}
      </p>
    );
  }

  function component(entry, idx) {
    const Component = components[entry.component];

    return (
      <Fragment key={idx}>
        {title(entry.type)}

        <Component
          user={user}
          {...entry.data}
          nextLink={nextLink}
          withoutTitle={true}
          unlimitedList={true}
          showLoginPopup={showLoginPopup}
          subscribeChannel={subscribeChannel}
          unsubscribeChannel={unsubscribeChannel}
        />
      </Fragment>
    );
  }

  function search(e) {
    e.preventDefault();

    if (channelsSearch) return;

    const query = e.target.search.value.trim();

    if (!query) return;

    location.href = `search?query=${query}&box=search`;
  }
}
